import api from './predictAPI'
const getMemberDetail = function(){
    const req = api.instance.get("v1/members-me",{
    headers: api.getSessionHeaders()
    })
    return req
  }
  const authAPI = {
    getMemberDetail

}
export default authAPI 
